
import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import AboutSection from '../../components/feature/AboutSection';
import SolutionsSection from '../../components/feature/SolutionsSection';
import ProductSection from '../../components/feature/ProductSection';
import ClientsSection from '../../components/feature/ClientsSection';
import ContactSection from '../../components/feature/ContactSection';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 to-slate-800">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <SolutionsSection />
        <ProductSection />
        <ClientsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
